import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ReactElement, useState } from "react";
import { IInfoBlockProps } from "../../../interfaces/props/IInfoBlockProps";

import classes from "./InfoBlock.module.css";

/**
 * Компонент выводит карточку с информацией.
 *
 * @param {IInfoBlockProps} props - Параметры компонента
 * @param {string} props.title - Заголовок карточки
 * @param {string | undefined} [props.description] - Описание карточки
 * @param {boolean} [props.isClosable] - Флаг возможности закрыть карточку
 * @param {() => void} [props.onClose] - Функция, которая будет вызвана при закрытии карточки
 * @param {string} [props.className] - Дополнительный класс для корневого элемента
 */
export function InfoBlock(props: IInfoBlockProps): ReactElement {
  const { title, description, isClosable, onClose, className = "" } = props;
  const [visible, setVisible] = useState(true);

  if (!visible) return <></>;

  function handleClose() {
    setVisible(false);
    if (onClose) onClose();
  }

  return (
    <div className={`${classes.infoBlock} ${className}`}>
      <div className={classes.infoBlock__content}>
        <h3 className={classes.infoBlock__title}>{title}</h3>
        {description && (
          <div className={classes.infoBlock__description}>{description}</div>
        )}
      </div>
      {isClosable && (
        <Button
          className={classes.infoBlock__closeButton}
          aria-label="Удалить"
          type="text"
          onClick={handleClose}
        >
          <CloseOutlined className={classes.infoBlock__closeIcon} />
        </Button>
      )}
    </div>
  );
}
